export default class Intercom {
  constructor (user = null, params) {
    this.user = user
    this.params = params
    window.intercomSettings = {
      app_id: "bmo7f66r",
      id: null,
      email: null,
      name: null,
      phone: null,
      created_at: null,
      advertiser: null,
      website: null
    }
  }
  init () {
    window.Intercom("boot", {
      app_id: "bmo7f66r",
      id: this.user.firebaseAccount.id,
      email: this.user.firebaseAccount.email,
      name: this.user.firebaseAccount.name,
      phone: this.user.firebaseAccount.phone,
      created_at: new Date(),
      advertiser: this.params.advertiser.name,
      website: this.params.advertiser.website
    })
    window.Intercom('show')
  }
  softUpdate () {
    window.Intercom('update')
  }
  hardUpdate () {
    window.Intercom("update", {
      app_id: "bmo7f66r",
      id: this.user.firebaseAccount.id,
      email: this.user.firebaseAccount.email,
      name: this.user.firebaseAccount.name,
      phone: this.user.firebaseAccount.phone,
      advertiser: this.params.advertiser.name,
      website: this.params.advertiser.website
    })
  }
  destroy () {
    window.Intercom('shutdown')
  }
}
